
  export default {
    computed: {
      current () { return this.$store.state.products.current; }
    },
    methods: {
      saveToCookies () {
        const productCookie = {
          'institution': this.current.institution ? this.current.institution.name : '',
          'plan': this.current.name,
          'link': this.current.url ? this.current.url.link : ''
        };
        this.$cookies.set('bonkers-ie-selected-product', productCookie);
      }
    }
  };
